<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="14" height="14" rx="7" fill="var(--sf-base-background-dark)" />
    <path
      d="M4 10L6.33568 4H7.6897L10 10H8.69676L8.3244 8.97458H5.6756L5.30324 10H4ZM6.06488 7.88136H7.94358L7.01269 5.28814L6.06488 7.88136Z"
      fill="var(--sf-base-icon-white)"
    />
  </svg>
</template>
